/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';

import Container from 'components/Container';
import { useTranslations } from 'next-intl';
import { Grid2 } from '@mui/material';

const FeaturesWithMobileScreenshot = (): JSX.Element => {
  const theme = useTheme();
  const t = useTranslations('GlobalExpansion');

  return (
    <Container>
      <Grid2 container spacing={4}>
        <Grid2
          container
          alignItems={'center'}
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Box>
            <Box marginBottom={2}>
              <Typography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
                {t('Full-Time Employment Without Borders')}
              </Typography>
              <Typography color="text.secondary" variant={'h6'}>
                {t('Hire and manage full-time employees')}
                <br />
                <br />
                {t('What Sailglobal Provides')}
              </Typography>
            </Box>
            <Grid2 container spacing={1}>
              {[
                'Comprehensive Employment',
                'HR Administration',
                'Risk Management',
              ].map((item, i) => (
                <Grid2
                  size={{
                    xs: 12,
                  }}
                  key={i}
                >
                  <Box
                    component={ListItem}
                    disableGutters
                    width={'auto'}
                    padding={0}
                  >
                    <Box
                      component={ListItemAvatar}
                      minWidth={'auto !important'}
                      marginRight={2}
                    >
                      <Box
                        component={Avatar}
                        bgcolor={theme.palette.background.level1}
                        width={20}
                        height={20}
                      >
                        <svg
                          width={12}
                          height={12}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </Box>
                    </Box>
                    <ListItemText primary={t(item)} />
                  </Box>
                </Grid2>
              ))}
            </Grid2>
          </Box>
        </Grid2>

        <Grid2
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Box
            sx={{
              // maxWidth: 336,
              position: 'relative',
              marginX: 'auto',
            }}
          >
            <Box
              component={'img'}
              src="/images/others/GlobalExpansion-image2.png"
              alt="Image Description"
              width={1}
              height={1}
              sx={{
                objectFit: 'cover',
                filter:
                  theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
              }}
            />
          </Box>
        </Grid2>
      </Grid2>
    </Container>
  );
};

export default FeaturesWithMobileScreenshot;
